import _ from 'lodash';

/* eslint-disable array-callback-return */
// Get updated templates by checking all filter conditions
export const getFilteredTemplates = ({ templates }) => {
  let allTemplates = [...templates];

  const filteredTemplates = { all: [], starred: [] };

  allTemplates.forEach((item) => {
    if (item?.starred && item.starred[0] === 'true') {
      filteredTemplates.starred.push(item);
    } else {
      filteredTemplates.all.push(item);
    }
  });

  return filteredTemplates;
};

// Get updated covers by chekcing all filter conditions
export const getFilteredCoversOrMedia = ({
  covers,
  medias,
  selectedCoverType,
  searchValue,
  sortValue,
}) => {
  let allCoversMedias = (covers || medias).sort((a, b) => {
    if (a.uploadedBy === 'user' && b.uploadedBy === 'admin') return -1;
    if (a.uploadedBy === 'admin' && b.uploadedBy === 'user') return 1;
    return 0;
  });

  if (selectedCoverType === 'full-page')
    allCoversMedias = allCoversMedias.filter((coverMedia) => coverMedia.type === 'full-page');
  else allCoversMedias = allCoversMedias.filter((coverMedia) => coverMedia.type !== 'full-page');

  allCoversMedias.sort((a, b) =>
    sortValue === 'asc'
      ? new Date(b.createdAt) - new Date(a.createdAt)
      : new Date(a.createdAt) - new Date(b.createdAt)
  );

  const filteredCoversMedias = { all: [], starred: [] };

  allCoversMedias.forEach((item) => {
    if (item?.starred && item.starred[0] === 'true') {
      filteredCoversMedias.starred.push(item);
    } else {
      filteredCoversMedias.all.push(item);
    }
  });

  filteredCoversMedias.starred = filteredCoversMedias.starred.map((item, index) => ({
    ...item,
    title:
      selectedCoverType === 'top-cover'
        ? `Top cover starred-${index + 1}`
        : `Full cover starred-${index + 1}`,
  }));

  filteredCoversMedias.all = filteredCoversMedias.all.map((item, index) => ({
    ...item,
    title: selectedCoverType === 'top-cover' ? `Top cover-${index + 1}` : `Full cover-${index + 1}`,
  }));

  const filterRegex = (cover) => {
    const searchRegex = new RegExp(_.escapeRegExp(searchValue), 'i');
    if (cover.title && cover.name) {
      return searchRegex.test(cover.title && cover.name);
    } else if (cover.name) {
      return searchRegex.test(cover.name);
    } else if (cover.title) {
      return searchRegex.test(cover.title);
    }
  };

  if (searchValue) {
    filteredCoversMedias.starred = filteredCoversMedias.starred.filter((cover) =>
      filterRegex(cover)
    );
    filteredCoversMedias.all = filteredCoversMedias.all.filter((cover) => filterRegex(cover));
  }

  return filteredCoversMedias;
};

// Get updated sections by chekcing all filter conditions
export const getFilteredSections = ({ sections, searchValue }) => {
  const allSections = sections;
  const filteredSections = { all: [], starred: [] };

  allSections.forEach((item) => {
    if (item?.starred && item.starred[0] === 'true') {
      filteredSections.starred.push(item);
    } else {
      filteredSections.all.push(item);
    }
  });

  if (searchValue) {
    const searchRegex = new RegExp(_.escapeRegExp(searchValue), 'i');

    filteredSections.starred = filteredSections.starred.filter(
      (section) =>
        searchRegex.test(section.title) ||
        searchRegex.test(section.libraryTitle) ||
        searchRegex.test(section.text)
    );

    filteredSections.all = filteredSections.all.filter(
      (section) =>
        searchRegex.test(section.title) ||
        searchRegex.test(section.libraryTitle) ||
        searchRegex.test(section.text)
    );
  }

  return filteredSections;
};

export const getFilteredCatalogs = ({ catalogs, searchValue }) => {
  const allCatalogs = catalogs;
  const filteredCatalogs = { all: [], starred: [] };

  allCatalogs.forEach((item) => {
    if (item?.starred && item.starred[0] === 'true') {
      filteredCatalogs.starred.push(item);
    } else {
      filteredCatalogs.all.push(item);
    }
  });

  if (searchValue) {
    const searchRegex = new RegExp(_.escapeRegExp(searchValue), 'i');
    filteredCatalogs.starred = filteredCatalogs.starred.filter((catalog) =>
      searchRegex.test(catalog.name)
    );
    filteredCatalogs.all = filteredCatalogs.all.filter((catalog) => searchRegex.test(catalog.name));
  }

  return filteredCatalogs;
};

/**
 * Contain title function
 *
 * @param {Object} tree
 * @param {string} str
 */
export const containTitle = (tree, str) => {
  let contains = false;
  if (tree.title?.toLowerCase() === str) {
    contains = true;
  }
  if (tree.title?.toLowerCase().indexOf(str) !== -1) {
    contains = true;
  } else if (tree?.children?.length) {
    for (let i = 0; i < tree.children.length; i++) {
      if (tree.children[i].title?.toLowerCase().indexOf(str) !== -1) {
        contains = true;
      }
      if (!contains && tree?.children[i]?.children?.length) {
        contains = containTitle(tree.children[i], str);
      }
    }
  } else {
    contains = false;
  }
  return contains;
};

/**
 * Handle tree search
 *
 * @param {Object} e
 */
export const handleTreeSearch = ({
  tempSearchValue,
  treeData,
  setIndexes,
  handleTreeData,
  initialTreeData,
  keyToBeSelected,
  fromModal,
  type,
  isDefaultFolder,
  isWixServices,
  isWixProducts,
  onKeySelect,
  toFolderKey,
}) => {
  let tempTreeData = treeData || {};
  let skipDefault = false;
  const tempTree = setIndexes(treeData);
  let tempTreeDataChildren = tempTree?.children || [];
  let match = false;

  if (tempTreeDataChildren?.length) {
    tempTreeData.children = tempTreeDataChildren.filter((child) => {
      if (child?.title?.toLowerCase() === tempSearchValue?.toLowerCase()) {
        match = true;
      }

      return containTitle(child, tempSearchValue);
    });
  }

  if (!match && tempSearchValue) {
    if (tempSearchValue === '') {
      if (tempTreeData.children[tempTreeData.children.length - 1].create) {
        tempTreeData.children.splice(-1, 1);
      }
    } else {
      if (tempTreeData?.children[tempTreeData.children.length - 1]?.create) {
        tempTreeData.children[
          tempTreeData.children.length - 1
        ].key = `newTemplateFolder_${tempSearchValue?.trim()}`;
        tempTreeData.children[tempTreeData.children.length - 1].title = tempSearchValue?.trim();
      } else {
        tempTreeData.children.push({
          children: null,
          default: true,
          create: true,
          key: `newTemplateFolder_${tempSearchValue?.trim()}`,
          path: '',
          title: tempSearchValue?.trim(),
          index: treeData.children.length,
        });
      }
    }
  } else if (!tempSearchValue) {
    tempTreeData = setIndexes(initialTreeData || {});
  }

  handleTreeData({
    data: tempTreeData,
    skipDefault,
    keyToBeSelected,
    fromModal,
    type,
    isDefaultFolder,
    isWixServices,
    isWixProducts,
    onKeySelect,
    toFolderKey,
  });
};

/**
 * Filter out "All Shared" and "All Catalogs" folders from tree data
 * @param {Object} treeData - The tree data to filter
 * @param {string} type - The type of the tree data
 * @returns {Object} - Filtered tree data
 */
export const filterTreeData = (treeData, type) => {
  if (!treeData || !treeData.children) {
    return treeData;
  }

  const filteredChildren = treeData.children.filter((child) => {
    // Filter out "All Shared" and "All Catalogs" folders
    const title = child.title?.toLowerCase() || '';
    const key = child.key?.toLowerCase() || '';

    if (
      title.includes('all shared') ||
      title.includes(`all ${type}`) ||
      title.includes('all starred') ||
      title.includes('default') ||
      title.includes('deliverables') ||
      key.includes('default-deliverables') ||
      key.includes('wix-services') ||
      key.includes('wix-products') ||
      key.includes('pipedrive-products') ||
      key.includes('hubspot-products') ||
      key.includes('divider-integration') ||
      key.includes('saved-deliverables') ||
      key === 'headers' ||
      key === 'section'
    ) {
      return false;
    }

    // Recursively filter children if they exist
    if (child.children && child.children.length > 0) {
      child.children = filterTreeData(child, type).children;
    }

    return true;
  });

  return {
    ...treeData,
    children: filteredChildren,
  };
};

/**
 * Handle tree search for modals without affecting the main tree data
 * This function provides the same search functionality as handleTreeSearch
 * but returns the modified tree data instead of calling handleTreeData
 *
 * @param {Object} params - Search parameters
 * @param {string} params.tempSearchValue - Search value
 * @param {Object} params.treeData - Original tree data
 * @param {Function} params.setIndexes - Function to set indexes
 * @param {Object} params.initialTreeData - Initial tree data for reset
 * @returns {Object} - Modified tree data
 */
export const handleModalTreeSearch = ({
  tempSearchValue,
  treeData,
  setIndexes,
  initialTreeData,
}) => {
  let tempTreeData = { ...treeData };
  let tempTreeDataChildren = tempTreeData?.children || [];
  let match = false;

  if (tempTreeDataChildren?.length) {
    tempTreeData.children = tempTreeDataChildren.filter((child) => {
      if (child?.title?.toLowerCase() === tempSearchValue.toLowerCase()) {
        match = true;
      }
      return child?.title?.toLowerCase().includes(tempSearchValue.toLowerCase());
    });
  }

  if (!match && tempSearchValue) {
    if (tempSearchValue === '') {
      if (tempTreeData.children[tempTreeData.children.length - 1]?.create) {
        tempTreeData.children.splice(-1, 1);
      }
    } else {
      console.log('tempTreeData', tempTreeData);

      if (
        tempTreeData?.children &&
        tempTreeData?.children[tempTreeData?.children?.length - 1]?.create
      ) {
        tempTreeData.children[
          tempTreeData.children.length - 1
        ].key = `newTemplateFolder_${tempSearchValue?.trim()}`;
        tempTreeData.children[tempTreeData.children.length - 1].title = tempSearchValue?.trim();
      } else if (tempTreeData?.children) {
        tempTreeData?.children?.push({
          children: null,
          default: true,
          create: true,
          key: `newTemplateFolder_${tempSearchValue?.trim()}`,
          path: '',
          title: tempSearchValue?.trim(),
          index: treeData.children.length,
        });
      }
    }
  } else if (!tempSearchValue) {
    tempTreeData = setIndexes(initialTreeData || {});
  }

  return tempTreeData;
};

// Custom handleTreeSearch for modals that doesn't affect the main tree
// This prevents the search functionality in modals from affecting the main ContentLibraryTree
/**
 * Handle modal tree search wrapper
 *
 * @param {Object} params
 * @param {string} params.tempSearchValue
 * @param {Object} params.treeData
 * @param {Function} params.setIndexes
 * @param {Object} params.initialTreeData
 * @param {Function} params.addKey
 * @param {Function} params.setModalTreeData
 * @param {Object} params.filteredTreeData
 * @returns {Object} - Modified tree data
 */
export const handleModalTreeSearchWrapper = ({
  tempSearchValue,
  treeData,
  setIndexes,
  initialTreeData,
  addKey,
  setModalTreeData,
  filteredTreeData,
}) => {
  let modifiedTreeData = handleModalTreeSearch({
    tempSearchValue,
    treeData,
    setIndexes,
    initialTreeData,
  });

  modifiedTreeData.key = '';
  addKey(modifiedTreeData, '', 1, filteredTreeData?.children?.length || 0);
  modifiedTreeData.children = modifiedTreeData?.children?.reverse();

  // Update only the modal tree data, not the main tree data
  // This ensures the main ContentLibraryTree remains unaffected by modal searches
  setModalTreeData(modifiedTreeData);
};

/**
 * Add new child from search
 *
 * @param {Array} treeSearchValue
 * @param {Array} selectedFolderKey
 * @param {Object} user
 * @param {Object} treeData
 * @param {Function} addChild
 */
export const addNewChildFromSearch = ({
  treeSearchValue,
  selectedFolderKey,
  user,
  treeData,
  addChild,
}) => {
  let _selectedFolderKey = selectedFolderKey;

  if (
    _selectedFolderKey === 'newTemplateFolder' ||
    _selectedFolderKey === 'catalogs' ||
    _selectedFolderKey === 'templates' ||
    _selectedFolderKey === 'shared-folder' ||
    _selectedFolderKey === 'deliverables' ||
    _selectedFolderKey === 'default-deliverables' ||
    _selectedFolderKey === 'wix-services' ||
    _selectedFolderKey === 'wix-products' ||
    _selectedFolderKey === 'pipedrive-products' ||
    _selectedFolderKey === 'hubspot-products'
  ) {
    _selectedFolderKey = '';
  }

  addChild({
    variables: {
      child: { title: treeSearchValue?.trim(), uid: user._id },
      key: `${_selectedFolderKey || ''}${_selectedFolderKey ? '.' : ''}children`,
      id: treeData._id,
    },
  });
};
